import React from 'react'
import PropTypes from 'prop-types'
import MobileMenu from './../MobileMenu'
import './style.scss'

class MobileHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: false,
      showMenu: false,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    const { toggled, showMenu } = this.state
    if (toggled) {
      this.setState({
        toggled: !toggled,
      })
      setTimeout(
        function () {
          this.setState({
            showMenu: !showMenu,
          })
        }.bind(this),
        500
      )
    } else {
      this.setState({
        showMenu: !showMenu,
      })
      setTimeout(
        function () {
          this.setState({
            toggled: !toggled,
          })
        }.bind(this),
        500
      )
    }
  }

  render() {
    const { menuItems, globals, isMobile } = this.props
    const { toggled, showMenu } = this.state
    return isMobile ? (
      <div className={'dhsv-mobile-header'}>
        <div className={'header' + (toggled ? ' is-opened' : '')}>
          <div className="brand">
            <a
              href={
                globals.custom_link ? globals.custom_link : globals.logo_link
              }
            >
              <img src={globals.logo_url} />
            </a>
          </div>
          <div
            className={'toggle' + (toggled ? ' open-toggle' : '')}
            onClick={this.handleClick}
          >
            <span />
            <span />
            <span />
          </div>
        </div>
        {showMenu ? (
          <MobileMenu
            menuItems={menuItems}
            activeMenu={toggled ? ' open-menu' : ''}
          />
        ) : null}
      </div>
    ) : null
  }
}

MobileHeader.propTypes = {
  isMobile: PropTypes.bool,
  globals: PropTypes.object,
  menuItems: PropTypes.array,
}

export default MobileHeader
